import classnames from 'classnames'

import { REVEAL_TIME_MS } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'
import { CharStatus } from '../../lib/statuses'

type Props = {
  value?: string
  status?: CharStatus
  isRevealing?: boolean
  isCompleted?: boolean
  position?: number
}

export const Cell = ({
  value,
  status,
  isRevealing,
  isCompleted,
  position = 0,
}: Props) => {
  const isFilled = value && !isCompleted
  const shouldReveal = isRevealing && isCompleted
  const animationDelay = `${position * REVEAL_TIME_MS}ms`
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'xxshort:w-11 xxshort:h-11 short:text-2xl short:w-12 short:h-12 w-14 h-14 border-solid border-2 flex items-center justify-center mx-0.5 text-4xl font-bold rounded-xl transition-all',
    {
      'bg-white border-slate-200 shadow-[0_3px_0_#cbd5e1]': !status,
      'border-slate-300 shadow-[0_3px_0_#94a3b8]': value && !status,
      'absent shadowed bg-slate-400 text-white border-slate-400 shadow-[0_3px_0_#94a3b8]':
        status === 'absent',
      'correct shadowed bg-orange-500 text-white border-orange-500 shadow-[0_3px_0_#ea580c]':
        status === 'correct' && isHighContrast,
      'present shadowed bg-cyan-500 text-white border-cyan-500 shadow-[0_3px_0_#0891b2]':
        status === 'present' && isHighContrast,
      'correct shadowed bg-green-500 text-white border-green-500 shadow-[0_3px_0_#16a34a]':
        status === 'correct' && !isHighContrast,
      'present shadowed bg-yellow-500 text-white border-yellow-500 shadow-[0_3px_0_#ca8a04]':
        status === 'present' && !isHighContrast,
      'cell-fill-animation': isFilled,
      'cell-reveal': shouldReveal,
    }
  )

  return (
    <div className={classes} style={{ animationDelay }}>
      <div className="letter-container" style={{ animationDelay }}>
        {value}
      </div>
    </div>
  )
}
